import { RecipeTag, RecipeTagCategories, User } from '@/api/types'
import i18n from '@/i18n'
import { groupBy } from '@/utils'
import { OriginalRecipe } from './EditOrCreateRecipe/EditOrCreateRecipe'

export type GroupedTagsType = {
  [key in RecipeTagCategories]: RecipeTag[]
}

export function groupTags(tags: RecipeTag[]) {
  return groupBy(tags, 'category') as GroupedTagsType
}

export function updateTranslationLabels(
  recipe: OriginalRecipe,
  selectedLanguage: string,
  label: string,
  translation: string,
) {
  const existingTranslations = recipe.i18nLabels ?? []

  const translationIdx = existingTranslations.findIndex(
    (translation) => translation.languageCode === selectedLanguage && translation.label === label,
  )

  const updated = {
    label,
    languageCode: selectedLanguage,
    translation,
  }

  if (translationIdx === -1) {
    existingTranslations.push(updated)
  } else {
    existingTranslations[translationIdx] = { ...existingTranslations[translationIdx], ...updated }
  }

  return existingTranslations
}

export type TranslationLabels = 'NAME' | 'PREPARATION_STEPS' | 'OTHER_INFO'

export function findI18nTranslation(
  recipe: OriginalRecipe,
  selectedLanguage: string,
  label: TranslationLabels,
): string | undefined {
  const translation = recipe.i18nLabels?.find(
    (translation) => translation.languageCode === selectedLanguage && translation.label === label,
  )

  return translation?.translation ?? ''
}

function getLastName(user: User) {
  return user.lastName && user.firstName != user.lastName ? ` ${user.lastName}` : ''
}

export function getUserFullName(user?: User) {
  if (user?.firstName) {
    return `${user.firstName}${getLastName(user)}`
  }

  return user ? `${user.email}` : ''
}

const DietOptions = i18n.t('recipe.dietOptions', { returnObjects: true })
export type DietType = keyof typeof DietOptions

const IntervalOptions = i18n.t('filters.intervalOptions', { returnObjects: true })
export type IntervalType = keyof typeof IntervalOptions
